<template>
  <!-- // 软性点评 -->
  <div class="resume-comment">
    <template>
      <div class="title">软性点评：</div>
      <div class="comment">
        <div class="sub">
          极端软性点评
          <template v-if="selectedTags.length > 0">
            (
            <a>{{ selectedTags.length }}</a
            >个)
          </template>
        </div>
        <div class="tags">
          <template v-for="(tag, index) in tags">
            <span :key="index" class="wrap">
              <a-checkable-tag
                class="tag"
                :checked="selectedTags.indexOf(tag) > -1"
                @change="checked => handleChange(tag, checked)"
                >{{ tag }}</a-checkable-tag
              >
              <a-icon
                type="close"
                style="pointer:cursor"
                v-if="index >= tagLength"
                @click="handleClose(tag)"
                class="close"
              />
            </span>
          </template>
          <a-input
            v-if="inputVisible"
            ref="input"
            type="text"
            size="small"
            :style="{ width: '78px' }"
            :value="inputValue"
            @change="handleInputChange"
            @blur="handleInputConfirm"
            @keyup.enter="handleInputConfirm"
          />
          <a-tag class="editTag" v-else @click="showInput">
            <a-icon type="plus" />
          </a-tag>
        </div>
        <div class="sub">软性点评：</div>
        <div class="options">
          <template v-for="item in options">
            <a-radio-group :key="item.id" v-model="item.checkValue" class="row">
              <a-row
                :key="item.id"
                type="flex"
                justify="space-between"
                align="middle"
              >
                <a-col span="2">{{ item.name }}</a-col>
                <template v-for="radio in item.children">
                  <a-col span="5" :key="radio.id">
                    <a-radio :value="radio.name">{{ radio.name }}</a-radio>
                  </a-col>
                </template>
              </a-row>
            </a-radio-group>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Api from "@/api";
export default {
  name: "SoftComment",
  data() {
    return {
      tags: [
        "没有明显极端形象",
        "眼、耳、口或鼻有明显异常",
        "皮肤特别黑",
        "特别矮",
        "特别胖",
        "脸部或其他部位明显疤",
        "明显部位纹身",
        "口吃",
        "谢顶",
        "普通话不标准"
      ],
      tagLength: 0,
      options: undefined,
      inputVisible: false,
      inputValue: "",
      selectedTags: [],
      selectedOptions: []
    };
  },
  async created() {
    this.getSoftSkill();
    this.tagLength = this.tags.length;
    let { tags } = await Api.resume.getUserTags();
    if (tags.length > 0) {
      let tag = tags.map(item => item.name);
      this.tags = [...this.tags, ...tag];
    }
    this.tagLength = this.tags.length;
  },
  mounted() {},
  methods: {
    async getSoftSkill() {
      let response = await Api.resume.softSkill();
      response.tree.forEach(item => {
        item.checkValue = "";
      });
      this.options = response.tree;
    },
    async handleClose(removedTag) {
      try {
        await Api.resume.deleteUserTag({ tag_name: removedTag });
        this.handleChange(removedTag, false);
        const tags = this.tags.filter(tag => tag !== removedTag);
        this.tags = [...tags];
      } catch (e) {}
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(function() {
        this.$refs.input.focus();
      });
    },

    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    async handleInputConfirm() {
      const inputValue = this.inputValue.trim();
      let tags = this.tags;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        try {
          await Api.resume.createUserTag({ tag_name: inputValue });
          tags = [...tags, inputValue];
          Object.assign(this, {
            tags,
            inputVisible: false,
            inputValue: ""
          });
        } catch (e) {}
      } else {
        inputValue && this.$message.info("请勿添加已有标签");
      }
      Object.assign(this, {
        inputVisible: false,
        inputValue: ""
      });
    },
    handleChange(tag, checked) {
      const { selectedTags } = this;
      const nextSelectedTags = checked
        ? [...selectedTags, tag]
        : selectedTags.filter(t => t !== tag);
      this.selectedTags = nextSelectedTags;
    },
    getCommentFormData() {
      let options = this.options
        .filter(item => item.checkValue.length > 0)
        .map(item => {
          return `${item.name}:${item.checkValue}`;
        });
      let tags = [
        ...this.selectedTags, //tag
        ...options //options
      ];
      if (tags.length > 2) {
        return tags.join(",");
      } else {
        this.$message.info("请选择至少3个点评");
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.resume-comment {
  min-height: 400px;
  padding-top: 30px;
  .title {
    font-weight: bold;
    font-size: 16px;
    color: #000;
    margin-bottom: 20px;
  }
  .sub {
    color: #333;
    margin-bottom: 16px;
  }
  .info {
    margin-bottom: 34px;
    padding: 20px 20px 5px 20px;
    border-radius: 3px;
    border: 1px solid rgba(228, 232, 235, 1);
    .row {
      margin-bottom: 10px;
      .col {
        display: flex;
        align-items: center;
        &.gap {
          span:not(:last-child) {
            margin-right: 16px;
          }
        }
        span {
          display: flex;
          align-items: center;
          &.name {
            font-size: 16px;
            font-weight: bold;
          }
          &.match {
            font-size: 16px;
            color: #fc5646;
            font-weight: bold;
          }
          &.time {
            color: #999;
            .anticon {
              margin-right: 5px;
              font-size: 16px;
            }
          }
          &.salary {
            font-size: 16px;
            color: #fc5646;
          }
          .anticon {
            font-size: 18px;
            margin-right: 5px;
          }
        }
        a {
          display: inline-block;
          margin-left: 20px;
          .anticon {
            margin-right: 5px;
          }
        }
        .ant-btn {
          margin-left: 20px;
        }
      }
    }
    .ant-divider-horizontal {
      margin: 18px 0;
    }
  }
  .comment {
    .tags {
      margin-bottom: 30px;
      .tag {
        line-height: 40px;
        padding: 0 20px;
        height: 40px;
        font-size: 14px;
        border-radius: 4px;
        margin-bottom: 12px;
        border: 1px solid rgba(220, 223, 230, 1);
      }
      .editTag {
        width: 78px;
        color: #606266;
        line-height: 40px;
        padding: 0 30px;
        height: 40px;
        font-size: 14px;
        border-radius: 4px;
        border: 1px dashed;
      }
      .ant-input {
        width: 78px;
        line-height: 40px;
        padding: 0 20px;
        height: 40px;
        font-size: 14px;
        border-radius: 4px;
        border: 1px solid rgba(220, 223, 230, 1);
      }
      .wrap {
        position: relative;
      }
      .close {
        font-size: 14px;
        color: #606266;
        position: absolute;
        top: -17px;
        right: 0;
      }
    }
  }
  .options {
    padding-bottom: 50px;
    .row {
      display: block;
      margin-bottom: 10px;
    }
  }
}
</style>
